/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_ReadyInputs */

const en_us2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to send.`)
};

const pt_br2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo pronto para enviar.`)
};

const es_419_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para enviar.`)
};

const pt_pt2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo pronto para enviar.`)
};

const fr_fr2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à envoyer.`)
};

const de_de2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zum Senden.`)
};

const it_it2_workout_after_ready = /** @type {(inputs: Workout_After_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto da inviare.`)
};

/**
* | output |
* | --- |
* | "Ready to send." |
*
* @param {Workout_After_ReadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_ready = /** @type {((inputs?: Workout_After_ReadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_ReadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_ready(inputs)
	if (locale === "es-419") return es_419_workout_after_ready(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_ready(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_ready(inputs)
	if (locale === "de-DE") return de_de2_workout_after_ready(inputs)
	if (locale === "it-IT") return it_it2_workout_after_ready(inputs)
	return en_us2_workout_after_ready(inputs)
});
export { workout_after_ready as "workout-after.ready" }